module.exports = __webpack_public_path__ + "static/media/white_knight.a7a9a5c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pieces/white_knight.png
// module id = 156
// module chunks = 0